import Login from '@/components/External/Login.tsx';
import ExternalWrapper from '@/components/ExternalWrapper.tsx';
import SiteWrapper from '@/components/Layout';
import { useAuth } from '@/providers/AuthProvider';
import Dashboard from './Dashboard/Dashboard.tsx';

const Application = () => {
  const auth = useAuth();

  if (!auth) {
    return (
      <ExternalWrapper>
        <Login />
      </ExternalWrapper>
    );
  }

  return (
    <SiteWrapper>
      <Dashboard />
    </SiteWrapper>
  );
};

export default Application;
